import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { DowngradeSurveyPage, Step } from 'features/cancellationSurvey'
import { useCallback, useEffect } from 'react'
import { z } from 'zod/v4'

export const downgradeSchema = z.object({
  step: z.enum(['feedback', 'confirm']).default('feedback'),
})

export type DowngradeSearch = z.infer<typeof downgradeSchema>

export const Route = createFileRoute('/_authenticated/workspaces/$subscriptionId/plan/downgrade/')({
  component: Page,
  validateSearch: downgradeSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Downgrade Subscription'),
      },
    ],
  }),
})

function Page() {
  const { step } = Route.useSearch()
  const navigate = Route.useNavigate()

  // Edge-case: if the initial step is 'confirm', redirect to 'feedback'.
  useEffect(
    () => {
      if (step === 'confirm') {
        navigate({ search: { step: 'feedback' } })
      }
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const changeStep = useCallback(
    (newStep: Step) => {
      switch (newStep) {
        case Step.Feedback:
          navigate({ search: { step: 'feedback' } })
          break

        case Step.Confirmation:
          navigate({ search: { step: 'confirm' } })
          break
      }
    },
    [navigate]
  )

  const activeStep = step === 'feedback' ? Step.Feedback : Step.Confirmation

  return <DowngradeSurveyPage activeStep={activeStep} changeStep={changeStep} />
}
